import Vue from 'vue';
import Http from './http';
import AvatarLetters from './avatar-letters';
import Bus from './bus';
import Cep from './cep';
import Dialog from './dialog';
import DigitalSignature from './digital-signature';
import DiscardSignature from './discard-signature';
import File from './file';
import Message from './message';
import Notification from './notification';
import PrintRecipe from './print-recipe';
import Storage from './storage';
import TimeDiff from './time/time-diff';
import Toast from './toast';

/**
 * Register plugins
 * @param {Object} params - Parameters
 * @param {Object} params.router - The Vue Router instance
 * @param {Object} params.store - The Vuex store instance
 */
export default (params) => {
  Vue.use(Http, params);
  Vue.use(AvatarLetters);
  Vue.use(Bus);
  Vue.use(Cep);
  Vue.use(Dialog);
  Vue.use(DigitalSignature);
  Vue.use(DiscardSignature);
  Vue.use(File);
  Vue.use(Message);
  Vue.use(Notification);
  Vue.use(PrintRecipe);
  Vue.use(Storage);
  Vue.use(TimeDiff);
  Vue.use(Toast);
};
